import React, { FunctionComponent, useEffect, useState, useRef, useContext, useCallback, useImperativeHandle } from 'react';
import throttle from 'lodash/throttle';
import bounds from "binary-search-bounds"
import cx from 'classnames';

// import styles from './articleIndex.module.less';

interface ContextType {
  postionData: {
    [key: string]: number
  };
  refeshFlag: boolean;
  current: string;
  intersectionKeys: string[];
  updatePositon: (key: string, position: number) => void;
  updateKeys: (key: string) => void,
  scrollByKey: (key: string) => void;
}

interface ObserverProps {
  name: string;
  threshold?: number;
  observerCallBack?: (name: string) => void;
  observerOnceCallBack?: (name: string) => void;
}

export const WrapperContext = React.createContext<ContextType>({
  postionData: {},
  refeshFlag: false,
  current: '',
  intersectionKeys: [],
  updatePositon: (key: string, position: number) => {},
  updateKeys: (key: string) => {},
  scrollByKey: () => {},
})

export const WrapperProvider = ({ children }) => {
  const [postionData, setPostion] = useState<ContextType['postionData']>({});
  const [refeshFlag, setFlag] = useState(false);
  const [current, setCurrent] = useState('');
  const intersectionKeys = useRef<string[]>([]);

  const updatePositon = (key: string, position: number) => {
    if (refeshFlag) {
      setFlag(false);
      return;
    }

    setPostion(prev => {
      const copy = {...prev};
      copy[key] = position > 80 ? position - 80 : position;

      const keyArr = Object.keys(copy);
      const valueArr = Object.values(copy);
      const currentKey = keyArr[bounds.le(valueArr, window.scrollY)];
      setCurrent(() => currentKey);
      
      return copy;
    })
  }
  
  const handleScroll = throttle(() => {
    !refeshFlag && setFlag(true);
  }, 500)

  const scrollByKey = (key: string) => {
    const top = postionData[key];

    if (top) {
      window.scroll(0, top);
      return
    }
  }

  const updateKeys = throttle((key: string) => {
    console.log(`updateKeys ${key}`)
    if (intersectionKeys.current.includes(key)) return;

    intersectionKeys.current = intersectionKeys.current.concat(key);
  }, 100)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [postionData, refeshFlag])

  // console.log(current);

  return (
    <WrapperContext.Provider value={{ postionData, updatePositon, updateKeys, refeshFlag, current, scrollByKey, intersectionKeys: intersectionKeys.current }}>
      { children }
    </WrapperContext.Provider>
  )
}

export const ObserverWrapper: FunctionComponent<ObserverProps> = ({ name, children, observerCallBack, observerOnceCallBack, threshold }) => {
  const [isVisibled, setVisible] = useState<boolean>(false);
  const currRef = useRef<HTMLDivElement>(null);
  const context = useContext(WrapperContext);

  const update = () => {
    if (currRef.current) {
      const positon = currRef.current.getBoundingClientRect().top + window.scrollY;

      context.updatePositon(name, positon);
    }
  }

  const initObserver = () => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        if (!isVisibled && !context.intersectionKeys.includes(name) && name) {
          console.log(`${name} update`)
          // context.updateKeys(name);
        }
        !isVisibled && observerOnceCallBack && observerOnceCallBack(name);
        observerCallBack && observerCallBack(name);
        !isVisibled && setVisible(true);
      }
    },  { threshold: [threshold ?? 0.65] })

    currRef.current && observer.observe(currRef.current);
  }

  useEffect(() => {
    update();
  }, [])

  useEffect(() => {
    initObserver();
  }, [context.intersectionKeys, isVisibled])

  // 超级测试不需要此功能
  // useEffect(() => {
  //   update();
  // }, [context.refeshFlag])

  return (
    <div ref={currRef}>
      {children}
    </div>
  )
}